import { CommonModule } from "@angular/common";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { ApiModule } from "./services/api/api.module";
import { GraphqlModule } from "./services/graphql/graphql.module";

/**
 * Migrate Modules TranslocoCoreModule, IconsModule to Targx Core
 */

@NgModule({
  imports: [
    CommonModule,
    GraphqlModule,],
  exports: [GraphqlModule],
})
export class TargxModule {
  /**
   * Constructor
   *
   * @param parentModule
   */
  constructor(@Optional() @SkipSelf() parentModule?: TargxModule) {
    if (parentModule) {
      throw new Error(
        "TargxModule has already been loaded. Import this module in the AppModule only!",
      );
    }
  }
}
